import { createTheme } from '@mui/material/styles';

export const getTheme = role => {
  const isSocio = role; // Detectar si el usuario es socio

  return createTheme({
    palette: {
      primary: {
        main: isSocio ? '#264653' : '#1E293B', // 🔥 Azul zafiro para socios, azul oscuro para invitados
        light: isSocio ? '#2A9D8F' : '#4B5563',
        dark: isSocio ? '#1B3A4B' : '#0F172A',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: isSocio ? '#E76F51' : '#A3A3A3', // 🔥 Naranja solar para socios, gris neutro para invitados
        light: isSocio ? '#F4A261' : '#D1D5DB',
        dark: isSocio ? '#C14A2E' : '#6B7280',
        contrastText: isSocio ? '#1E293B' : '#FFFFFF',
      },
      background: {
        default: isSocio ? '#F3F4F6' : '#F3F4F6', // 🔥 Fondo celeste claro para socios, gris claro para invitados
        paper: isSocio ? '#FFFFFF' : '#E5E7EB',
      },
      text: {
        primary: isSocio ? '#264653' : '#111827', // 🔥 Azul zafiro para socios, gris oscuro para invitados
        secondary: isSocio ? '#6B7280' : '#6B7280',
      },
      success: {
        main: isSocio ? '#16A34A' : '#16A34A', // 🔥 Verde brillante para socios, verde oscuro para invitados
      },
      error: {
        main: isSocio ? '#D72638' : '#991B1B', // 🔥 Rojo intenso para socios, rojo oscuro para invitados
      },
      warning: {
        main: isSocio ? '#F4A261' : '#D97706', // 🔥 Naranja cálido para socios, más apagado para invitados
      },
      info: {
        main: isSocio ? '#457B9D' : '#64748B', // 🔥 Azul acero para socios, gris azulado para invitados
      },
    },
    typography: {
      fontFamily: "'Poppins', 'Roboto', sans-serif",
      fontSize: 15,
      h1: {
        fontWeight: 700,
        fontSize: '3rem',
        color: isSocio ? '#264653' : '#E5E7EB', // 🔥 Azul zafiro para socios, claro para invitados
      },
      h2: {
        fontWeight: 600,
        fontSize: '2.5rem',
        color: isSocio ? '#E76F51' : '#D1D5DB',
      },
      button: { textTransform: 'uppercase', fontWeight: 500, color: '#FFFFFF' },
    },
    shape: {
      borderRadius: 12,
    },
    shadows: [
      'none',
      '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)',
      '0px 3px 6px rgba(0, 0, 0, 0.16), 0px 3px 6px rgba(0, 0, 0, 0.23)',
      '0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)',
      ...Array(21).fill('0px 5px 15px rgba(0, 0, 0, 0.2)'), // Ahora hay 25 sombras
    ],
  });
};
